const UserDetails = ({ title = "", value = "" }) => {
  return (
    <div className="mt-[18px]">
      <label className="text-[#42495280] font-Apparat font-[500] md:font-[600] text-[12px] md:text-[16px] leading-[17px] md:leading-[20px]">
        {title}
      </label>
      <div className="font-Apparat font-[600] text-[14px] md:text-[18px] leading-[20px] md:leading-[24px]">{value}</div>
    </div>
  )
}
const SubHeadings = ({ title }) => {
  return (
    <h2 className="font-Apparat font-[600] md:font-[700] text-[12px] md:text-[16px] leading-[13.9px] md:leading-[19.2px] mb-[8px] mt-[28px] ml-[23px] text-[#42495240] uppercase">
      {title}
    </h2>
  )
}
const Labels = ({ title }) => {
  return (
    <label className="font-Apparat text-[#424952] font-[500] md:font-[600]  text-[14px] md:text-[18px] leading-[20px] md:leading-[24px]">
      {title}
    </label>
  )
}

const InfoContainer = ({ icon, list, title, className }) => {
  return (<>
    <div className="flex gap-[8px]">
      <div className={`p-[10px] h-[36px] w-[36px] text-center rounded-full ${className}`}>
        {icon}
      </div>
      <div>
        <p className="font-Apparat font-[600] md:font-[700] text-[14px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%] text-[#424952]  max-w-[100%] md:max-w-[80%] mb-[8px]">
          {title}
        </p>
        {list?.map((item, index) => <p className="font-Apparat font-[500] md:font-[600] text-[14px] md:text-[20px] leading-[20px] md:leading-[24px] tracking-[-2%] text-[#42495280]" key={index}>
          {`${index + 1}. ${item}`}
        </p>)}
      </div>

    </div>
  </>)
}

export { UserDetails, SubHeadings, Labels, InfoContainer }